import type { IApplicationState } from 'shared/types/redux';

export const selectPikLandingChannel = (state: IApplicationState) => state.cpd.pikLandingChannel;
